import { CONTROL } from '../../../../components';
import styles from "../../../styles.module.css";
import { generateCpuItems, generateRamItems, getDisk } from '../../../utils';
import { cascadeLakeServerGenItem, ecsSpecificationGenCpuToRamMap, ecsSpecificationGenToCpuMap, EcsSpecificationItem, ecsSpecificationItems, ecsSpecificationToGenMap, iceLakeServerGenItem, OsItem, osItems } from './AdvancedCloudServer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DeploymentZonesNumberItem = {
  '1AZ': '1AZ',
  '3AZ': '3AZ'
};
var deploymentZonesNumberItems = [{
  value: DeploymentZonesNumberItem['1AZ'],
  label: '1AZ'
}, {
  value: DeploymentZonesNumberItem['3AZ'],
  label: '3AZ'
}];
export var CLOUD_CONTAINER_ENGINE_FORM_CONFIG = {
  ui: [['deploymentZonesNumber', 'masterNodeNumber'], 'masterNodeNumberAlert', 'ecs'],
  controls: {
    deploymentZonesNumber: {
      type: CONTROL.Segmented,
      accessorKey: 'cce.deploymentZonesNumber',
      defaultValue: DeploymentZonesNumberItem['1AZ'],
      items: deploymentZonesNumberItems,
      decoratorProps: {
        label: 'Количество зон развертывания мастер-нод',
        labelTooltip: 'При использовании режима 3AZ будут созданы три мастер-узла, а при отказе одного мастер-узла будет создаваться кластер.'
      }
    },
    masterNodeNumber: {
      type: CONTROL.Segmented,
      accessorKey: 'cce.masterNodeNumber',
      defaultValue: '50',
      items: generateCpuItems([50, 200, 1000]),
      decoratorProps: {
        label: 'Максимальное количество узлов',
        labelTooltip: ' Количество серверов (виртуальных машин), на которых разворачивают и запускают контейнеры'
      },
      watchedControls: {
        deploymentZonesNumber: 'cce.deploymentZonesNumber'
      },
      relateFn: function relateFn(_ref) {
        var deploymentZonesNumber = _ref.deploymentZonesNumber;
        if (deploymentZonesNumber === DeploymentZonesNumberItem['3AZ']) {
          return {
            items: generateCpuItems([50, 200, 1000, 2000])
          };
        }
      }
    },
    masterNodeNumberAlert: {
      type: CONTROL.Alert,
      uiProps: {
        description: 'При выборе 1 000 узлов и более активируется Kubernetes Turbo.',
        link: {
          target: '_blank',
          href: 'https://cloud.ru/docs/cce/ug/topics/overview__comparison.html',
          text: 'Сравнение Kubernetes и Kubernetes Turbo'
        },
        visible: false
      },
      accessorKey: 'turbo',
      watchedControls: {
        masterNodeNumber: 'cce.masterNodeNumber'
      },
      relateFn: function relateFn(_ref2) {
        var masterNodeNumber = _ref2.masterNodeNumber;
        if (Number(masterNodeNumber) >= 1000) {
          return {
            uiProps: {
              visible: true
            }
          };
        }
      }
    },
    ecs: {
      type: CONTROL.ToggleObject,
      switchKey: 'cce.vmServerNeeded',
      decoratorProps: {
        label: 'Узлы для запуска контейнера'
      },
      control: {
        type: CONTROL.Object,
        ui: [['ecsSpecification', 'ecsGen'], ['ecsCpu', 'ecsRam'], ['counter'], ['evsSystemDisk'], ['evsAdditionalDisks']],
        controls: {
          ecsSpecification: {
            type: CONTROL.SelectSingle,
            accessorKey: 'ecs.specification',
            defaultValue: EcsSpecificationItem.GeneralPurpose,
            items: ecsSpecificationItems,
            decoratorProps: {
              label: 'Спецификация узлов',
              labelTooltip: /*#__PURE__*/_jsxs("ul", {
                className: styles.tip,
                children: [/*#__PURE__*/_jsx("li", {
                  children: "General-Purpose \u0434\u043B\u044F \u0432\u0435\u0431-\u0441\u0435\u0440\u0432\u0435\u0440\u043E\u0432 \u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0441 \u043D\u0435\u0431\u043E\u043B\u044C\u0448\u043E\u0439 \u0440\u0430\u0431\u043E\u0447\u0435\u0439 \u043D\u0430\u0433\u0440\u0443\u0437\u043A\u043E\u0439;"
                }), /*#__PURE__*/_jsx("li", {
                  children: "Dedicated General-Purpose \u0434\u043B\u044F \u0431\u0430\u0437 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0441\u0440\u0435\u0434\u043D\u0435\u0439 \u0438 \u0432\u044B\u0441\u043E\u043A\u043E\u0439 \u043D\u0430\u0433\u0440\u0443\u0437\u043A\u0438;"
                }), /*#__PURE__*/_jsx("li", {
                  children: "Memory-Optimized \u0434\u043B\u044F \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439, \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u044E\u0449\u0438\u0445 \u0431\u043E\u043B\u044C\u0448\u0438\u0435 \u043E\u0431\u044A\u0435\u043C\u044B \u0434\u0430\u043D\u043D\u044B\u0445;"
                }), /*#__PURE__*/_jsx("li", {
                  children: "Disk-intensive \u0434\u043B\u044F Big Data \u0438 \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0451\u043D\u043D\u044B\u0445 \u0432\u044B\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0439;"
                }), /*#__PURE__*/_jsx("li", {
                  children: "Ultra-high I/O \u0434\u043B\u044F ElasticSearch \u0438 \u0432\u044B\u0441\u043E\u043A\u043E\u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0435\u043B\u044F\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u0431\u0430\u0437 \u0434\u0430\u043D\u043D\u044B\u0445."
                })]
              })
            }
          },
          ecsOs: {
            type: CONTROL.Segmented,
            accessorKey: 'ecs.os',
            defaultValue: OsItem.Linux,
            items: osItems,
            decoratorProps: {
              label: 'Операционная система'
            }
          },
          counter: {
            type: CONTROL.Stepper,
            accessorKey: 'counter',
            defaultValue: 1,
            decoratorProps: {
              label: 'Количество узлов'
            },
            uiProps: {
              min: 1,
              max: 99
            }
          },
          ecsCpu: {
            type: CONTROL.SelectSingle,
            accessorKey: 'ecs.cpu',
            defaultValue: '1',
            items: generateCpuItems([1, 2, 4, 8]),
            decoratorProps: {
              label: 'Количество vCPU',
              labelTooltip: 'Виртуальный процессор'
            },
            watchedControls: {
              ecsSpecification: 'ecs.specification',
              serverGen: 'ecs.gen'
            },
            relateFn: function relateFn(_ref3) {
              var _ecsSpecificationGenT;
              var ecsSpecification = _ref3.ecsSpecification,
                serverGen = _ref3.serverGen;
              var items = (ecsSpecificationGenToCpuMap === null || ecsSpecificationGenToCpuMap === void 0 ? void 0 : (_ecsSpecificationGenT = ecsSpecificationGenToCpuMap[ecsSpecification]) === null || _ecsSpecificationGenT === void 0 ? void 0 : _ecsSpecificationGenT[serverGen]) || [];
              if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
                return {
                  items: generateCpuItems(items)
                };
              }
            }
          },
          ecsRam: {
            type: CONTROL.Segmented,
            accessorKey: 'ecs.ram',
            defaultValue: '1',
            items: generateRamItems([1, 2, 4]),
            decoratorProps: {
              label: 'Объём RAM',
              labelTooltip: 'Оперативная память'
            },
            watchedControls: {
              ecsSpecification: 'ecs.specification',
              serverGen: 'ecs.gen',
              cpu: 'ecs.cpu'
            },
            relateFn: function relateFn(_ref4) {
              var _ecsSpecificationGenC, _ecsSpecificationGenC2;
              var ecsSpecification = _ref4.ecsSpecification,
                serverGen = _ref4.serverGen,
                cpu = _ref4.cpu;
              var items = ecsSpecificationGenCpuToRamMap === null || ecsSpecificationGenCpuToRamMap === void 0 ? void 0 : (_ecsSpecificationGenC = ecsSpecificationGenCpuToRamMap[ecsSpecification]) === null || _ecsSpecificationGenC === void 0 ? void 0 : (_ecsSpecificationGenC2 = _ecsSpecificationGenC[serverGen]) === null || _ecsSpecificationGenC2 === void 0 ? void 0 : _ecsSpecificationGenC2[cpu];
              if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
                return {
                  items: generateRamItems(items)
                };
              }
            }
          },
          ecsGen: {
            type: CONTROL.Segmented,
            accessorKey: 'ecs.gen',
            defaultValue: cascadeLakeServerGenItem.value,
            items: [cascadeLakeServerGenItem, iceLakeServerGenItem],
            decoratorProps: {
              label: 'Поколение',
              labelTooltip: 'Поколение сервера'
            },
            watchedControls: {
              ecsSpecification: 'ecs.specification'
            },
            relateFn: function relateFn(_ref5) {
              var ecsSpecification = _ref5.ecsSpecification;
              return {
                items: ecsSpecificationToGenMap[ecsSpecification] || []
              };
            }
          },
          evsSystemDisk: getDisk({
            space: {
              accessorKey: 'evs.systemDisk.diskSpace',
              defaultValue: 50,
              uiProps: {
                min: 50,
                max: 1530
              }
            },
            specification: {
              accessorKey: 'evs.systemDisk.specification'
            }
          }),
          evsAdditionalDisks: {
            type: CONTROL.Array,
            max: 23,
            accessorKey: 'evs.additionalDisks',
            defaultValue: [],
            addText: 'Добавить диск',
            ui: ['disk'],
            controls: {
              disk: getDisk({
                space: {
                  accessorKey: 'diskSpace',
                  defaultValue: 100,
                  uiProps: {
                    min: 100,
                    max: 32760
                  }
                },
                specification: {
                  accessorKey: 'specification'
                }
              })
            }
          }
        }
      }
    }
  }
};